
<!--US Page-->
<div class="dtfcontactus" *ngIf="!isCanadaPortal">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


    <!--Banner-->
    <section class="mbfs-home-hero"  style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Website_ContactUs_Header.jpg);">
      <section class="mbfs-home-hero__header">
       <h2 class="mbfs-home-hero__header-subtitle">
            {{ 'ContactUs.ContactTitle' | translate }}
        </h2>
         <p class="subheader">
            {{ 'ContactUs.ContactHeader' | translate }}
         </p>
        
      </section>
    </section>
    
     <ul>
      <div class="staticflex-contact">
         <div>
            <div class="column-text">
               <div class="section-title by-phone-mail">{{ 'ContactUs.ByPhone' | translate }}</div>
               <div class="section-title other-titles">{{ 'ContactUs.CustomerService' | translate }}</div>
               <div class="phone-number">{{ 'ContactUs.CustomerServicePhone' | translate }}</div>
               <div class="section-title other-titles">{{ 'ContactUs.FleetServices' | translate }}</div>
               <div class="phone-number">{{ 'ContactUs.FleetServicesPhone' | translate }}</div>
               <div class="section-title other-titles">{{ 'ContactUs.LeaseMaturities' | translate }}</div>
               <div class="phone-number">{{ 'ContactUs.LeaseMaturitiesPhone' | translate }}</div>
            </div>            
         </div>

         <div>
            <div class="column-text">
               <div class="section-title by-phone-mail">{{ 'ContactUs.ByMail' | translate }} <br>{{ 'ContactUs.Correspondence' | translate }} <span><a style="color: #00566A;" href="{{this.localRedirect}}/home/paymentoptions">{{ 'ContactUs.paymentoptions' | translate }} </a></span> {{ 'ContactUs.instructions' | translate }}</div> 
               <div class="address">{{ 'ContactUs.MailingAddress1' | translate }}</div>
               <div class="address">{{ 'ContactUs.MailingAddress2' | translate }}</div>
               <div class="address">{{ 'ContactUs.MailingAddress3' | translate }}</div>
            </div>
         </div>
      </div>
   </ul>     
</div>

<div class="dtfcontactus" *ngIf="isCanadaPortal">
  <div class="dtf-alertpage"></div>
    <!--Banner-->
   <section class="mbfs-home-hero"  style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Website_ContactUs_Header.jpg);">
     <section class="mbfs-home-hero__header">
      <h2 class="mbfs-home-hero__header-subtitle">
        {{ 'ContactUs.ContactTitle' | translate }}
       </h2>
       
        <p class="subheader">
           {{ 'ContactUs.ContactHeader' | translate }}
        </p>
       
     </section>
   </section>
   <ul *ngIf="isFrench"> <!--Canada French Brochures-->
      <div class="staticflex-contact">
         <div>
            <div class="column-text">
               <div class="section-title by-phone-mail">{{ 'ContactUs.ByPhone' | translate }}</div>
               <div class="section-title other-titles">{{ 'ContactUs.ByPhone1' | translate }}</div>
               <div class="phone-number">{{ 'ContactUs.ByPhone2' | translate }}</div>

               <div class="section-title by-phone-mail">{{ 'ContactUs.ByEmail' | translate }}</div>
               <div class="phone-number">{{ 'ContactUs.ByEmail1' | translate }}</div>

            </div>            
         </div>

         <div>
            <div class="column-text">
               <div class="section-title by-phone-mail">{{ 'ContactUs.ByMail' | translate }}</div>
               <div class="address">{{ 'ContactUs.ByMail1' | translate }}</div>
               <div class="address">{{ 'ContactUs.ByMail2' | translate }}</div>
               <div class="address">{{ 'ContactUs.ByMail3' | translate }}</div>

               <div class="section-title by-phone-mail">{{ 'ContactUs.HoursOfOperation' | translate }}</div>
               <div class="address">{{ 'ContactUs.HoursOfOperation1' | translate }}</div>
               <div class="address">{{ 'ContactUs.HoursOfOperation2' | translate }}</div>
            </div>
         </div>
      </div>
   </ul>
   
  <!--Canada English Brochures-->
  <ul *ngIf="!isFrench">
   <div class="staticflex-contact">
      <div>
         <div class="column-text">
            <div class="section-title by-phone-mail">{{ 'ContactUs.ByPhone' | translate }}</div>
            <div class="section-title other-titles">{{ 'ContactUs.ByPhone1' | translate }}</div>
            <div class="phone-number">{{ 'ContactUs.ByPhone2' | translate }}</div>

            <div class="section-title by-phone-mail">{{ 'ContactUs.ByEmail' | translate }}</div>
            <div class="phone-number">{{ 'ContactUs.ByEmail1' | translate }}</div>

         </div>            
      </div>

      <div>
         <div class="column-text">
            <div class="section-title by-phone-mail">{{ 'ContactUs.ByMail' | translate }}</div>
            <div class="address">{{ 'ContactUs.ByMail1' | translate }}</div>
            <div class="address">{{ 'ContactUs.ByMail2' | translate }}</div>
            <div class="address">{{ 'ContactUs.ByMail3' | translate }}</div>

            <div class="section-title by-phone-mail">{{ 'ContactUs.HoursOfOperation' | translate }}</div>
            <div class="address">{{ 'ContactUs.HoursOfOperation1' | translate }}</div>
            <div class="address">{{ 'ContactUs.HoursOfOperation2' | translate }}</div>
         </div>
      </div>
   </div>   
</ul>
<div class="section-title accessibility-footer">{{ 'ContactUs.Accessibility' | translate }}</div>
</div>
